<section class="export-header d-flex flex-row">
    <div class="export-header__logo">
        <img src="/assets/images/ActivexChangeLogoWhite.png">
    </div>

    <div class="details d-flex flex-grow-1">
        <div class="icon">
            <mat-icon>insert_chart</mat-icon>
        </div>
        <div>
            <h1>{{ config?.title }}</h1>
            <p>{{ config?.subTitle }}</p>
            <p>Exported: {{ dateTime }}</p>
        </div>
    </div>
</section>